import { z } from 'zod';
import type { SpectrumMixDoc, SpectrumMixLightChannel } from '@ledium/types';
import { nameSchema, descriptionSchema, spectralRangesSchema, idRefSchema } from './primitives.js';

const spectrumMixLightChannelSchema: z.ZodType<SpectrumMixLightChannel> = z.object({
    id: idRefSchema,
    intensity: z.number().min(0),
    intensityPercent: z.number().min(0).max(100),
    intensityRanges: z.object({
        pfd: spectralRangesSchema,
        irradiance: spectralRangesSchema
    })
});

type SpectrumMixInput = Omit<SpectrumMixDoc, '_id' | 'locked' | 'linked' | 'lightRecipeId'> & { lightRecipeId?: string };

export const spectrumMixSchema: z.ZodType<SpectrumMixInput> = z.object({
    name: nameSchema,
    description: descriptionSchema,
    zoneId: z.string().min(1),
    lightChannels: z.array(spectrumMixLightChannelSchema),
    lightRecipeId: z.string().optional()
});
